module.exports = __webpack_public_path__ + "01_long_black.285fda63.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_long_black.png
// module id = 0pwF
// module chunks = 0